// src/components/FacebookFeed.js
import React, { useEffect } from "react";
import tw from "twin.macro";
import WordSpacedText from "./WordSpacedText"

const Container = tw.div`flex flex-col items-center mt-12`;
const Heading = tw.h2`text-3xl lg:text-4xl font-bold mb-10 text-center`; // Increased font size and margin

const FacebookFeed = () => {
  useEffect(() => {
    if (!window.FB) {
      const script = document.createElement("script");
      script.src = "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v16.0";
      script.async = true;
      script.defer = true;
      script.crossOrigin = "anonymous";
      document.body.appendChild(script);
    } else {
      window.FB.XFBML.parse();
    }
  }, []);

  return (
    <Container>
      <WordSpacedText><Heading>Facebook Feeds</Heading></WordSpacedText>
      <div style={{ display: "flex", justifyContent: "center", marginTop: "2rem" }}> {/* Increased spacing */}
        <div
          className="fb-page"
          data-href="https://www.facebook.com/jmardg/"
          data-tabs="timeline"
          data-width="500"
          data-height="700"
          data-small-header="false"
          data-adapt-container-width="true"
          data-hide-cover="false"
          data-show-facepile="true"
        ></div>
      </div>
    </Container>
  );
};

export default FacebookFeed;
